import { useContext, useState } from "react";
import UiContext from "../../../store/ui-context";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";

export const useAPIEditPengisianMinyak = (props) => {
  const { onConfirmed } = props;

  const uiContext = useContext(UiContext);
  const { requestGetOne, requestPost, loading } = useAPIRequest();

  const [data, setData] = useState({});
  const [error, setError] = useState({});

  //  API call section

  const fetchData = async ({ id, extraData }) => {
    return requestGetOne({
      fullUrl: `api/transaksi/kendaraanpengisianminyak/one/${id}`,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        const newData = reformatDataAfterFetch(_data);
        if (extraData) {
          setData({ ...extraData, ...newData });
        } else {
          setData(newData);
        }
      },
    });
  };

  const saveData = async () => {
    setError({});

    return requestPost({
      fullUrl: `/api/transaksi/kendaraanpengisianminyak/save`,
      body: reformatDataBeforeSave(data),
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        uiContext.showSuccessMsg("Success", message);
        const newData = reformatDataAfterFetch(_data);
        onConfirmed(newData);
      },
    });
  };

  // other function section

  const validate = () => {
    let valid = true;
    let newError = {};

    if (!data.kendaraan_id || data.kendaraan_id <= 0) {
      newError = { ...newError, kendaraan_id: "Kendaraan harus dipilih" };
      valid = false;
    }

    if (!data.jenis_minyak_id || data.jenis_minyak_id <= 0) {
      newError = { ...newError, jenis_minyak_id: "Jenis Minyak harus dipilih" };
      valid = false;
    }

    if (!data.speedo_akhir || data.speedo_akhir <= 0) {
      newError = { ...newError, speedo_akhir: "KM akhir harus diisi" };
      valid = false;
    }

    if (!data.tanggal || !(data.tanggal instanceof Date)) {
      newError = { ...newError, tanggal: "Tanggal harus diisi" };
      valid = false;
    }

    if (!data.jam || !(data.jam instanceof Date)) {
      newError = { ...newError, jam: "Jam harus diisi" };
      valid = false;
    }

    if (!data.harga_per_liter || data.harga_per_liter <= 0) {
      newError = { ...newError, harga_per_liter: "Harga Per Liter harus diisi" };
      valid = false;
    }

    if (!data.jumlah || data.jumlah <= 0) {
      newError = { ...newError, jumlah: "Jumlah Liter harus diisi" };
      valid = false;
    }

    if (!data.total_harga || data.total_harga <= 0) {
      newError = { ...newError, total_harga: "Total Harga harus diisi" };
      valid = false;
    }

    setError(newError);

    setTimeout(() => {
      setError("");
    }, 3000);

    return valid;
  };

  const reformatDataBeforeSave = (_data) => {
    const newData = data;
    if (data.tanggal instanceof Date && data.jam instanceof Date) {
      const datePart = format(data.tanggal, "yyyy-MM-dd"); // Extract "2025-05-02"
      const timePart = format(data.jam, "HH:mm:ss"); // Extract "09:54:50"

      const combinedDateTimeString = `${datePart} ${timePart}`;
      const combinedDateTime = new Date(combinedDateTimeString);

      if (!isNaN(combinedDateTime)) {
        newData.tanggal_transaksi = format(
          combinedDateTime,
          "yyyy-MM-dd HH:mm:ss"
        );
      } else {
        console.error("Invalid date-time combination:", combinedDateTimeString);
        newData.tanggal_transaksi = format(new Date(), "yyyy-MM-dd HH:mm:ss");
      }
    } else {
      newData.tanggal_transaksi = format(new Date(), "yyyy-MM-dd HH:mm:ss");
    }
    return newData;
  };

  const reformatDataAfterFetch = (_data) => {
    return _data;
  };

  const fetchDataOrCreateNew = ({ id, extraData }) => {
    if (id && id > 0) {
      fetchData({ id, extraData });
    } else {
      if (extraData) {
        setData({ ...generateNewData(), ...extraData });
      } else {
        setData(generateNewData());
      }
    }
  };

  const generateNewData = () => {
    return {
      tanggal_transaksi: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
      tanggal: new Date(),
      jam: new Date(),
    };
  };

  // handle ui event section

  const handleOnConfirm = () => {
    const valid = validate();
    if (valid) {
      saveData();
    }
  };

  return {
    loading,
    data,
    setData,
    error,
    setError,
    fetchDataOrCreateNew,
    handleOnConfirm,
    onConfirmed,
  };
};
